import { useCallback } from "react";
import { useParams } from "react-router-dom";
import Launchpad from "./Launchpad";
import { useSessionFetcher } from "src/pods/auth/useSessionFetcher";
import { appMetadataGroups as groups } from "src/pods/groups";
import { appMetadataList as list } from "src/pods/list";
import { appMetadataNoise as noise } from "src/pods/noise";
import { useDismissWelcomeNux } from "src/pods/nuxMetadata/useDismissNux";
import { appMetadataPairshare as pairshare } from "src/pods/pairshare";
import { appMetadataRadio as radio } from "src/pods/radio";
import { appMetadataRandom as random } from "src/pods/random";
import { remoteClose } from "src/pods/realtime";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";
import { appMetadataTimer as timer } from "src/pods/timer";
import { appMetadataToday as today } from "src/pods/today";

export default function LaunchpadContainer() {
  const { classId, mountPoint } = useParams<{ classId: string; mountPoint: string }>();

  const { data: session } = useSessionFetcher({});
  const isLoggedIn = !!session;
  const userConfig = session?.userConfig;
  const dismissWelcomeNux = useDismissWelcomeNux();

  const shouldRenderWelcome = isLoggedIn && !userConfig?.metaData?.toolkitWelcomeDismissed;

  const handleRemoteClose = useCallback(() => dispatchToolkitReduxAction(remoteClose()), []);

  if (!classId || !mountPoint) return null;

  return (
    <Launchpad
      classId={classId}
      mountPoint={mountPoint}
      apps={[timer(), random(), groups(), noise(), list(), pairshare(), today(), radio()]}
      shouldRenderWelcome={shouldRenderWelcome}
      dismissWelcomeNux={dismissWelcomeNux}
      remoteClose={handleRemoteClose}
    />
  );
}
